import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    background-color: rgba(96, 159, 148, 0.2);
  }
  50% {
    background-color: rgba(96, 159, 148, 0.4);
  }
  100% {
    background-color: rgba(96, 159, 148, 0.2);
  }
`;

const SkeletonCard = styled.div`
  background-color: #1A2E2E;
  border-radius: 12px;
  border: 1px solid #2C4A4A;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SkeletonImage = styled.div`
  width: 100%;
  height: 200px;
  background-color: rgba(96, 159, 148, 0.2);
  border-radius: 8px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

const SkeletonLine = styled.div<{ width: string, height: string }>`
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: rgba(96, 159, 148, 0.2);
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

const SkeletonLoader: React.FC = () => {
  return (
    <SkeletonCard>
      <SkeletonImage />
      <SkeletonLine width="70%" height="20px" />
      <SkeletonLine width="50%" height="16px" />
      <SkeletonLine width="80%" height="16px" />
      <SkeletonLine width="60%" height="16px" />
      <SkeletonLine width="40%" height="16px" />
    </SkeletonCard>
  );
};

export default SkeletonLoader;